import type { useTranscodeProgressFragment } from '../../shared/gql/generated/TranscodeProgress';
import type { AssetState } from '../types';

export function getStateForInteractive(
  transcodesFragment: ReturnType<typeof useTranscodeProgressFragment>
): AssetState | undefined {
  if (!transcodesFragment) {
    return undefined;
  }

  const asset = transcodesFragment.data;

  if (asset.__typename !== 'InteractiveAsset') {
    return undefined;
  }

  return asset.media?.interactiveTranscodes?.some(
    (t) => t?.encodeStatus === 'SUCCESS' || t?.encodeStatus === 'WARNING'
  )
    ? 'complete'
    : 'interactive';
}
